import { Text, SimpleGrid, Flex, Box, Img } from '@chakra-ui/react'
import Banner from '../../assets/img/contact_us/banner.jpg';
import Phone from '../../assets/img/contact_us/phone.png';
import ContactInfo from './sections/contact';
import FormContact from './sections/form';
import { useTranslation } from 'react-i18next';
import { fontSizesByLang } from '../../helpers/fontSizesByLang';

function ContactPage() {
  const { t, i18n } = useTranslation();
  const fontSizes = fontSizesByLang[i18n.language];

  return (
    <Flex bg='#1E1D1D' direction={'column'}>

      <Box position="relative" height={{ base: '110vh', md: '80vh', lg: '85vh' }}
        justifyContent={'center'}
        alignContent={'center'}
        alignItems={'center'}>

        <Box
          position="absolute"
          inset="0"
          bgImage={`url(${Banner})`}
          bgSize="cover"
          bgPos="center"
          bgRepeat="no-repeat"
          opacity={0.2}
          zIndex={0}

        />

        <Box position="relative"
          zIndex={1}
          p={{ base: '10%', md: '8%' }}
          width={'100%'}
        >
          <SimpleGrid columns={{ base: 1, md: 2 }}
            gap={{ base: '10%', md: '0%', lg: '10%' }}
          >
            <Flex direction={'column'}
              w={'100%'}
              mt={{ base: '20%', md: '0%' }}

            >
              <Text
                color={'white'}
                textTransform="uppercase"
                fontWeight={'bold'}
                fontSize={fontSizes.tittlefont}
                fontFamily={'Roboto Condensed'}
                letterSpacing={'initial'}
              >
                {t("contactus-tittle1")} <br />
                <Text as={'span'} color={'#AE8245'}>
                  {t("contactus-tittle1.2")}
                </Text>
              </Text>
              <Text color={'#929292'} fontFamily={'Inter'} fontSize={fontSizes.textfont} fontWeight={'medium'} mb={'5%'} mt={'2%'}>
                {t("contactus-info1")}
              </Text>

              <Flex align={'center'} gap={5} fontFamily={'Inter'} mt={'10%'}>
                <Img src={Phone} width={{ base: '10%', md: '6%' }} height={'auto'} />
                <Text color={'#AE8245'} fontFamily={'Inter'} fontSize={{ base: '90%', md: '110%' }}>
                  +1 956 251 6530
                </Text>
              </Flex>

            </Flex>

            <ContactInfo />
          </SimpleGrid>
        </Box>

      </Box>



      <Flex
        direction={'column'}
        alignItems={{ base: 'center', md: 'center' }}
        mt={'5%'}
        p={{ base: '5%', md: '0%' }}
        id="quote-form"
      >
        <Text
          color={'white'}
          textTransform="uppercase"
          fontWeight={'bold'}
          fontSize={fontSizes.tittlefont}
          fontFamily={'Roboto Condensed'}
          letterSpacing={'initial'}
        >
          {t("contactus-tittle6")}{' '}
          <Text as={'span'}
            color={'#AE8245'}
            display={{ base: 'none', md: 'inline' }}>
            {t("contactus-tittle6.2")}
          </Text>
        </Text>

        <Text
          color={'#AE8245'}
          textTransform="uppercase"
          fontWeight={'bold'}
          fontSize={{ base: '250%', md: '85px' }}
          fontFamily={'Roboto Condensed'}
          letterSpacing={'initial'}
          display={{ base: 'flex', md: 'none' }}
        >
          {t("contactus-tittle6.2")}
        </Text>


        <Text color={'#929292'} fontFamily={'Inter'} fontSize={fontSizes.textfont} fontWeight={'medium'} mb={'5%'} mt={'2%'}>
          {t("contactus-info6")}
        </Text>
        <FormContact />
      </Flex>

    </Flex >



  )
}

export default ContactPage